window.merge_objects = (obj1,obj2)->
  obj3 = {}
  for attrname of obj1
    obj3[attrname] = obj1[attrname]
  for attrname of obj2
    obj3[attrname] = obj2[attrname]
  obj3

window.params_from_url = (url)->
  params = {}
  splitted_url = url.split('#')
  splitted_url = splitted_url[0].split('?')
  return params if splitted_url.length == 1 or splitted_url[1] == ''
  string_params = splitted_url[1]
  if string_params.match(/&/)
    string_params = string_params.substring(1, string_params.length) if string_params.match(/^&/)
    string_params = string_params.replace(/&/g,"=")
  split_params_get = string_params.split("=")
  $.each split_params_get, (i,param)->
    if not ((i/2)+"").match(/\./) or (i/2)==0
      if param.match(/%5B%5D/)
        _param = param.replace('%5B%5D','')
        params[_param] ||= []
        params[_param].push split_params_get[i+1]
      else if param.match(/\[\]/)
        _param = param.replace('[]','')
        params[_param] ||= []
        params[_param].push split_params_get[i+1]
      else
        params[param] = split_params_get[i+1]
    else return
  params

window.add_params_to_url = (url, params)->
  final_url = null
  splitted_url = url.split('?')
  params_url = params_from_url(url)
  if typeof params == 'object'
    params_url = merge_objects(params_url, params)
  else if typeof params == 'string'
    _params = params_from_url("?"+params)
    params_url = merge_objects(params_url, _params)
  all_params = []
  $.each params_url, (k,v)->
    if typeof v == 'object'
      $.each v, (k2,v2)->
        all_params.push k+"[]="+v2
    else
      all_params.push k+"="+v
  if all_params.length > 0
    new_url = splitted_url[0]+"?"+all_params.join('&')
  else
    new_url = splitted_url[0]
  new_url

window.remove_params_from_url = (url, params)->
  base_url = url.split('?')[0]
  url_params = params_from_url(url)
  $.each params, (i,param)->
    delete url_params[param]
  add_params_to_url(base_url, url_params)

# Prendo la posizione scrollata [left, top]
document.getScroll = ->
  if window.pageYOffset != undefined
    return [pageXOffset, pageYOffset]
  else
    d = document
    r = d.documentElement
    b = d.body
    sx = r.scrollLeft || b.scrollLeft || 0
    sy = r.scrollTop || b.scrollTop || 0
    return [sx, sy]

# Validazione
window.Validator = {}
Validator.email_regexp = /^([\w\.\-\+]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/
Validator.presence = (input,default_value="") ->
  return input.is(':checked') if input.attr('type') == 'checkbox'
  value = $.trim(input.val())
  return !(value == "" || value == default_value)
Validator.format = (input,pattern) ->
  value = input.val()
  return pattern.test(value)
Validator.addError = (input,message,options={}) ->
  error_class = if options.error_class? then options.error_class else "error-msg"
  error_color = if options.error_color? then options.error_color else "#ff0000"
  input.css('border',"1px solid #{error_color}")
  input.addClass('field-error')
  mb = input.css('margin-bottom')
  ml = ""
  if input.prev('label').length > 0 and not input.hasClass('full-width')
    ml = parseInt(input.prev('label').css('margin-right'),10) + input.prev('label').outerWidth()
    ml = "margin-left: #{ml}px"
  input.css('margin-bottom','0px')
  if input.nextAll("div.#{error_class}").length == 0
    if input.attr('type') == 'checkbox' and input.parent('.field').length > 0
      input.parent('.field').append "<div class='#{error_class}' style='display:block; color: #{error_color}; margin-bottom: #{mb}; #{ml};'><b>#{message}</b></div>"
    else
      input.after "<div class='#{error_class}' style='display:block; color: #{error_color}; margin-bottom: #{mb}; #{ml};'><b>#{message}</b></div>"
  else
    input.nextAll("div.#{error_class}").fadeIn('fast')
Validator.removeError = (input,options={}) ->
  error_class = if options.error_class? then options.error_class else "error-msg"
  normal_color = if options.normal_color? then options.normal_color else "#B7B7B7"
  remove = if options.remove? then options.remove else true
  msg = input.nextAll("div.#{error_class}")
  mb = msg.css('margin-bottom')
  input.css('border',"1px solid #{normal_color}").css('margin-bottom',mb)
  input.removeClass('field-error')
  msg.fadeOut("fast")
  if remove
    msg.remove()

window.register_event = (cat,act,label,value)->
  console.log "trackEvent\n\rcat: #{cat}\n\ract: #{act}\n\rlabel: #{label}\n\rvalue: #{value}"
  _gaq.push(['_trackEvent', cat, act, label, value])

tracker = ()->
  $("form").each ()->
    form = $(this)
    if form.data().trackerCategory? and form.data().trackerAction?
      form.on "submit", ()->
        cat = form.data().trackerCategory
        act = form.data().trackerAction
        label = form.data().trackerLabel
        value = form.data().trackerValue
        register_event(cat, act, label, value)

center_txt_v = (obj,nh)->
    h = obj.height()
    mt = Math.ceil (h-nh)/2
    mt = mt*-1
    mt1 = mt+'px'
    obj.css {'paddingTop' : mt1}
    obj.css {'paddingBottom' : mt1}

sendRequest = (el)->
  form = el.parent("form")
  email = form.find('.demo_request_account_email')
  name = form.find('.demo_request_account_name')
  surname = form.find('.demo_request_account_surname')
  cell = form.find('.demo_request_account_mobile')
  denom = form.find('.demo_request_society_name')
  ok = true;
  if name.val()=="" || name.val()=="Il tuo nome"
    name.css('border','2px solid #B81010')
    form.find('.error-name').show()
    ok = false
  else
    name.css('border','1px solid #B7B7B7')
    form.find('.error-name').hide()
  if surname.val()=="" || surname.val()=="Il tuo cognome"
    surname.css('border','2px solid #B81010')
    form.find('.error-surname').show()
    ok = false
  else
    surname.css('border','1px solid #B7B7B7')
    form.find('.error-surname').hide()
  if cell.val()=="" || cell.val()=="Cellulare"
    cell.css('border','2px solid #B81010')
    form.find('.error-mobile').show()
    ok = false
  else
    cell.css('border','1px solid #B7B7B7')
    form.find('.error-mobile').hide()
  if !Validator.email_regexp.test(email.val())
    email.css('border','2px solid #B81010')
    form.find('.error-email').show()
    ok = false
  else
    email.css('border','1px solid #B7B7B7')
    form.find('.error-email').hide()
  if denom.val()=="" || denom.val()=="Nome associazione"
    denom.css('border','2px solid #B81010')
    form.find('.error-society-name').show()
    ok = false
  else
    denom.css('border','1px solid #B7B7B7')
    form.find('.error-society-name').hide()
  if ok
    form.submit()

sendRequestHome = ()->
  email = $('#demo_request_account_email')
  name = $('#demo_request_account_name')
  surname = $('#demo_request_account_surname')
  cell = $('#demo_request_account_mobile')
  denom = $('#demo_request_society_name')
  ok = true
  if name.val()=="" || name.val()=="Il tuo nome"
    name.css('border','2px solid #B81010')
    $('#error-name').show()
    ok = false
  else
    name.css('border','1px solid #B7B7B7')
    $('#error-name').hide()
  if surname.val()=="" || surname.val()=="Il tuo cognome"
    surname.css('border','2px solid #B81010')
    $('#error-surname').show()
    ok = false
  else
    surname.css('border','1px solid #B7B7B7')
    $('#error-surname').hide()
  if cell.val()=="" || cell.val()=="Cellulare"
    cell.css('border','2px solid #B81010')
    $('#error-mobile').show()
    ok = false
  else
    cell.css('border','1px solid #B7B7B7')
    $('#error-mobile').hide()
  if !Validator.email_regexp.test(email.val())
    email.css('border','2px solid #B81010')
    $('#error-email').show()
    ok = false
  else
    email.css('border','1px solid #B7B7B7')
    $('#error-email').hide()
  if denom.val()=="" || denom.val()=="Nome associazione"
    denom.css('border','2px solid #B81010')
    $('#error-society-name').show()
    ok = false
  else
    denom.css('border','1px solid #B7B7B7')
    $('#error-society-name').hide()
  if ok
    $("#new_demo_request").submit()

sendRequestExtended = ()->
  ok = true
  email = $('#demo_extended_account_email')
  name = $('#demo_extended_account_name')
  surname = $('#demo_extended_account_surname')
  cell = $('#demo_extended_account_mobile')
  denom = $('#demo_extended_day_starting')
  day = $('#demo_extended_society_name')
  time = $('#demo_extended_time_starting')
  trattamento = $('#trattamento')
  if name.val()==""
    name.css('border','2px solid #F00')
    name.parent().children('div').show()
    ok = false
  else
    name.css('border','1px solid #B7B7B7')
    name.parent().children('div').hide()
  if surname.val()==""
    surname.css('border','2px solid #F00')
    surname.parent().children('div').show()
    ok = false
  else
    surname.css('border','1px solid #B7B7B7')
    surname.parent().children('div').hide()
  if cell.val()==""
    cell.css('border','2px solid #F00')
    cell.parent().children('div.empty').show()
    ok = false
  else
    cell.css('border','1px solid #B7B7B7')
    cell.parent().children('div').hide()
  if !Validator.email_regexp.test(email.val())
    email.css('border','2px solid #F00')
    if email.val()==""
      email.parent().children('div.empty').show()
      email.parent().children('div.error').hide()
    else
      email.parent().children('div.error').show()
      email.parent().children('div.empty').hide()
    ok = false
  else
    email.css('border','1px solid #B7B7B7')
    email.parent().children('div').hide()
  if denom.val()==""
    denom.css('border','2px solid #F00')
    denom.parent().children('div').show()
    ok = false
  else
    denom.css('border','1px solid #B7B7B7')
    denom.parent().children('div').hide()
  if !trattamento.attr('checked')
    trattamento.parent().children('div').show()
  else
    trattamento.parent().children('div').hide()
  if day.val()==""
    day.css('border','2px solid #F00')
    day.parent().children('div').show()
    ok = false
  else
    day.css('border','1px solid #B7B7B7')
    day.parent().children('div').hide()
  if time.val()==""
    time.css('border','2px solid #F00')
    time.parent().children('div').show()
    ok = false
  else
    time.css('border','1px solid #B7B7B7')
    time.parent().children('div').hide()
  if ok
    form = $("#new_demo_extended")
    submitIubendaForm(form) if form.hasClass('iubenda')
    form.submit()

sendRequestDemo = ()->
  ok = true
  email = $('#demo_request_account_email')
  denom = $('#demo_request_society_name')
  trattamento = $('#trattamento')
  #name = $('#demo_request_account_name')
  #surname = $('#demo_request_account_surname')
  #cell = $('#demo_request_account_mobile')
  #if name.val()==""
  #  name.css('border','2px solid #F00')
  #  name.parent().children('div').show()
  #  ok = false
  #else
  #  name.css('border','1px solid #B7B7B7')
  #  name.parent().children('div').hide()
  #if surname.val()==""
  #  surname.css('border','2px solid #F00')
  #  surname.parent().children('div').show()
  #  ok = false
  #else
  #  surname.css('border','1px solid #B7B7B7')
  #  surname.parent().children('div').hide()
  #if cell.val()==""
  #  cell.css('border','2px solid #F00')
  #  cell.parent().children('div.empty').show()
  #  ok = false
  #else
  #  cell.css('border','1px solid #B7B7B7')
  #  cell.parent().children('div').hide()
  if !Validator.email_regexp.test(email.val())
    email.css('border','2px solid #F00')
    if email.val()==""
      email.parent().children('div.empty').show()
      email.parent().children('div.error').hide()
    else
      email.parent().children('div.error').show()
      email.parent().children('div.empty').hide()
    ok = false
  else
    email.css('border','1px solid #B7B7B7')
    email.parent().children('div').hide()
  if denom.val()==""
    denom.css('border','2px solid #F00')
    denom.parent().children('div').show()
    ok = false
  else
    denom.css('border','1px solid #B7B7B7')
    denom.parent().children('div').hide()
  if !trattamento.attr('checked')
    trattamento.parent().children('div').show()
  else
    trattamento.parent().children('div').hide()
  return ok

sendMailContacts = ()->
  ok = true
  email = $('#info_request_account_email')
  name = $('#info_request_account_name')
  surname = $('#info_request_account_surname')
  cell = $('#info_request_account_mobile')
  text = $('#info_request_text')
  trattamento = $('#trattamento')
  if name.val() == ""
    name.css('border','2px solid #F00')
    name.parent().children('div').show()
    ok = false
  else
    name.css('border','1px solid #B7B7B7')
    name.parent().children('div').hide()
  if surname.val() == ""
    surname.css('border','2px solid #F00')
    surname.parent().children('div').show()
    ok = false
  else
    surname.css('border','1px solid #B7B7B7')
    name.parent().children('div').hide()
  if cell.val() == ""
    cell.css('border','2px solid #F00')
    cell.parent().children('div.empty').show()
    ok = false
  else
    cell.css('border','1px solid #B7B7B7')
    cell.parent().children('div').hide()
  if !Validator.email_regexp.test(email.val())
    email.css('border','2px solid #F00')
    if email.val() == ""
      email.parent().children('div.empty').show()
      email.parent().children('div.error').hide()
    else
      email.parent().children('div.error').show()
      email.parent().children('div.empty').hide()
    ok = false
  else
    email.css('border','1px solid #B7B7B7')
    email.parent().children('div').hide()
  if text.val() == ""
    text.css('border','2px solid #F00')
    text.parent().children('div').show()
    ok = false
  else
    text.css('border','1px solid #B7B7B7')
    text.parent().children('div').hide()
  if !trattamento.attr('checked')
    trattamento.parent().children('div').show()
  else
    trattamento.parent().children('div').hide()
  if ok
    form = $('#new_info_request')
    submitIubendaForm(form) if form.hasClass('iubenda')
    form.submit()

#window.inizializeMapContacts = ()->
#  if window.init_contacts_map == undefined
#    window.init_contacts_map = true
#    directionsService = new google.maps.DirectionsService()
#    if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test"
#      lat = 30.2699728
#      lng = -97.7451924
#      title = 'TeamArtist Inc'
#    else
#      lat = 45.531818
#      lng = 9.368819
#      title = 'dSmart s.r.l.'
#    markerArray = []
#    latlng = new google.maps.LatLng(lat,lng)
#    directionsDisplay = new google.maps.DirectionsRenderer({draggable: true})
#    myOptions = {
#      zoom: 16
#      center: latlng
#      mapTypeId: google.maps.MapTypeId.SATELLITE
#      mapTypeControl: false
#    }
#    map = new google.maps.Map(document.getElementById("fancy-maps"), myOptions)
#    marker = new google.maps.Marker({
#      position: latlng
#      title: title
#      map: map
#    })
#    directionsDisplay.setMap(map)
#    stepDisplay = new google.maps.InfoWindow()
#    directionsDisplay.setPanel(document.getElementById("directions"))

checkFormContacts = (name_id,surname_id,phone_id,email_id,subject_id,description_id)->
  ok = true
  name = if name_id then $("##{name_id}") else $("#zd_name")
  surname = if surname_id then $("##{surname_id}") else $("#zd_surname")
  phone = if phone_id then $("##{phone_id}") else $("#zd_phone")
  email = if email_id then $("##{email_id}") else $("#zd_email")
  subject = if subject_id then $("##{subject_id}") else $("#zd_subject")
  description = if description_id then $("##{description_id}") else $("#zd_description")
  unless Validator.presence(name)
    msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Can't be blank" else "Devi compilare questo campo"
    Validator.addError name, msg
    ok = false
  else
    Validator.removeError name
  if surname.length > 0
    unless Validator.presence(surname)
      msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Can't be blank" else "Devi compilare questo campo"
      Validator.addError surname, msg
      ok = false
    else
      Validator.removeError surname
  if phone.length > 0
    unless Validator.presence(phone)
      msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Can't be blank" else "Devi compilare questo campo"
      Validator.addError phone, msg
      ok = false
    else
      Validator.removeError phone
  unless Validator.format(email,Validator.email_regexp)
    msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Email is invalid" else "Email non vailda"
    Validator.addError email, msg
    ok = false
  else
    Validator.removeError email
  unless Validator.presence(subject)
    msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Can't be blank" else "Devi compilare questo campo"
    Validator.addError subject, msg
    ok = false
  else
    Validator.removeError subject
  unless Validator.presence(description)
    msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Can't be blank" else "Devi compilare questo campo"
    Validator.addError description, msg
    ok = false
  else
    Validator.removeError description
  if $("#trattamento").length > 0
    trattamento = $("#trattamento")
    if !trattamento.is(':checked')
      trattamento.parent().children('div').show()
      ok = false
    else
      trattamento.parent().children('div').hide()
  if $("#zd_product").length > 0
    product = $("#zd_product")
    unless Validator.presence(product)
      msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Can't be blank" else "Devi compilare questo campo"
      Validator.addError product, msg
      ok = false
    else
      Validator.removeError product
  return ok

checkFormAppointment = (form)->
  ok = true
  name = if form then form.find(".appointment-name") else $("#appointment-name")
  surname = if form then form.find(".appointment-surname") else $("#appointment-surname")
  email = if form then form.find(".appointment-email") else $("#appointment-email")
  email_confirmation = if form then form.find(".appointment-email-confirmation") else $("#appointment-email-confirmation")
  mobile_phone = if form then form.find(".appointment-mobile-phone") else $("#appointment-mobile-phone")
  trattamento = if form then form.find("input[name='trattamento']") else $("#trattamento")
  if Validator.presence(email_confirmation)
    ok = false
  unless Validator.presence(name)
    msg = if $("html").attr('lang') != 'it-IT' then "Can't be blank" else "Devi compilare questo campo"
    Validator.addError name, msg
    ok = false
  else
    Validator.removeError name
  unless Validator.presence(surname)
    msg = if $("html").attr('lang') != 'it-IT' then "Can't be blank" else "Devi compilare questo campo"
    Validator.addError surname, msg
    ok = false
  else
    Validator.removeError surname
  unless Validator.format(email,Validator.email_regexp)
    msg = if $("html").attr('lang') != 'it-IT' then "Email is invalid" else "Email non vailda"
    Validator.addError email, msg
    ok = false
  else
    Validator.removeError email
  if mobile_phone.length > 0
    unless Validator.presence(mobile_phone)
      msg = if $("html").attr('lang') != 'it-IT' then "Can't be blank" else "Devi compilare questo campo"
      Validator.addError mobile_phone, msg
      ok = false
    else
      Validator.removeError mobile_phone
  if trattamento.length > 0
    unless Validator.presence(trattamento)
      msg = if $("html").attr('lang') != 'it-IT' then "Flag this box" else "Spunta questa casella"
      Validator.addError trattamento, msg
      ok = false
    else
      Validator.removeError trattamento
  return ok

#funzioni per mappa in contatti-new
markerArray = [];
secondo_giro_getLatLong = false;
window.getLatLong = (address, callback)->
  address = address.replace ".","+"
  geo = new google.maps.Geocoder
  geo.geocode {'address':address},(results, status)->
    if status == google.maps.GeocoderStatus.OK && results.length > 0
      callback(results[0].geometry.location)
    else if !secondo_giro_getLatLong
      secondo_giro_getLatLong = true
      approx_addr = $('#map_wrapper').data().approx
      if approx_addr.length > 0
        getLatLong(approx_addr, callback)

latlng = {}
directionsDisplay = {}
window.initialize = (geometry_location)->
  if typeof(geometry_location) == "undefined"
    return

  latlng = new google.maps.LatLng geometry_location.lat(),geometry_location.lng()

  directionsDisplay = new google.maps.DirectionsRenderer {draggable: true}
  myOptions =
    zoom: 16
    center: latlng
    mapTypeId: google.maps.MapTypeId.ROADMAP
    mapTypeControl: false
  map = new google.maps.Map document.getElementById("map_canvas"), myOptions
  marker = new google.maps.Marker
    position: latlng
    title: $('#map_wrapper').data().title
    map: map
  directionsDisplay.setMap(map)
  stepDisplay = new google.maps.InfoWindow()
  directionsDisplay.setPanel document.getElementById("route-info")

window.keypress = (e)->
  Ucode = if e.keyCode then e.keyCode else e.charCode
  if Ucode == 13
    calcRoute()

window.calcRoute = ()->
  directionsService = new google.maps.DirectionsService()
  start = $("#start_route").val()
  end = latlng
  request =
    origin: start,
    destination: end
    travelMode: google.maps.DirectionsTravelMode.DRIVING
  directionsService.route request, (response, status)->
    if status == google.maps.DirectionsStatus.OK
      directionsDisplay.setDirections response
  $('#route-info').show()

showSteps = (directionResult)->
  myRoute = directionResult.routes[0].legs[0]

  for i in [0...myRoute.steps.length]
    marker = new google.maps.Marker
      position: myRoute.steps[i].start_point
      map: map
    attachInstructionText marker, myRoute.steps[i].instructions
    markerArray[i] = marker

attachInstructionText = (marker, text)->
  google.maps.event.addListener marker, 'click', ()->
    stepDisplay.setContent text
    stepDisplay.open map, marker
#end funzioni per mappa in contatti-new

show_overlay = ()->
  $("#overlay").show()
hide_overlay = ()->
  $("#overlay").hide()

window.move_submenu = ->
  w_window = $(window).width()
  menu_top = $("#menu-top")
  $("#header ul.children").each ->
    return if $(@).attr("id") == "menu-ass"
    if w_window < 831
      menu_top.after $(@) if $("#menu-top + ##{$(@).attr("id")}").length == 0
    else
      link = $("#link-#{$(@).attr("id")}")
      link.parent().append $(@) if $("#link-#{$(@).attr("id")} + ##{$(@).attr("id")}").length == 0

window.add_close_submenu = (menu_name)->
  menu = $("##{menu_name}")
  if $(window).width() < 831
    menu.prepend "<li id='close-#{menu_name}' class='close-submenu' rel='link-#{menu_name}'><a href='#'>Chiudi</a></li>" if $("#close-#{menu_name}").length == 0
  else
    $("#close-#{menu_name}").remove()

window.close_submenus = (parent=false, animation=true)->
  $("#header ul.children:visible").each ->
    if animation
      $(@).slideUp(250)
    else
      $(@).hide()
  if parent and $(window).width() < 830 and $('#menu-top').is(':visible')
    $("#menu-top-small").trigger "click"

window.fix_dialog_dimension = (_dialog)->
  _dialog = _dialog.parents(".ui-dialog") unless _dialog.hasClass("ui-dialog")
  w_window = $(window).width()
  width_dialog = _dialog.outerWidth()
  _dialog.data("width", width_dialog) unless _dialog.data("width")
  if parseInt(_dialog.data("width"), 10) < w_window
    _dialog.removeClass("fullwidth")
    new_left = (w_window - width_dialog) / 2
    _dialog.css "left", "#{new_left}px"
  else
    _dialog.css "left", "0px"
    _dialog.addClass("fullwidth")
  div_close = _dialog.find(".ui-dialog-titlebar-close")
  div_title = _dialog.find(".ui-dialog-title")
  if (div_title.offset().left + div_title.outerWidth()) >= div_close.offset().left
    div_close.addClass("ion-close-round")
  else
    div_close.removeClass("ion-close-round")

window.default_dialog_options =
  width: 800
  height: "auto"
  autoOpen: false
  modal: true
  resizable: false
  closeText: "Chiudi o premi il tasto ESC"
  open: ->
    fix_dialog_dimension($(@))

window.extract = (obj)->
  for _var of obj
    @[_var] = obj[_var]

window.refreshCarousel = (firstCall=false)->
  w_window = $(window).width()
  if $("#box-carousel-ass").length > 0
    arrows_top = ($("#box-carousel-ass img").height() / 2) - 8
    $("#box-carousel-ass .arrow").css "top", arrows_top
    if w_window < 661 and w_window > 410
      if parseInt($("#box-carousel-ass").data().scroll, 10) != 2
        $("#box-carousel-ass").data "scroll", 2
        $("#box-carousel-ass").gencarousel("refresh") unless firstCall
    else if w_window < 411
      if parseInt($("#box-carousel-ass").data().scroll, 10) != 1
        $("#box-carousel-ass").data "scroll", 1
        $("#box-carousel-ass").gencarousel("refresh") unless firstCall
    else
      if parseInt($("#box-carousel-ass").data().scroll, 10) != 3
        $("#box-carousel-ass").data "scroll", 3
        $("#box-carousel-ass").gencarousel("refresh") unless firstCall

sticky_footer = ->
  w_window = $(window).width()
  $('#box-footer').removeAttr 'style'
  $('#content-page').removeAttr 'style'
  if w_window > 500
    h = $('#box-footer').height()
    $('#box-footer').css
      marginTop: "-#{h}px"
    $('#content-page').css
      paddingBottom: "#{h}px"

# Fix dimensioni video nella pagina home-b
set_height_video_home_b = ->
  $('#video-home_wrapper').removeAttr 'style' if $('#video-home_wrapper').length > 0 and $('#video-home_wrapper').attr('style').match /width/
  if $(window).width() > 880 or $(window).width() <= 605
    box_w = $('#box-video-home').width()
    box_w = 575 if box_w > 575
    box_h = Math.floor box_w/1.81
  else
    box_w = 575
    box_h = 317
  if $('#video-home').length > 0 and jwplayer('video-home') != null
    jwplayer('video-home').resize box_w, box_h

fix_video_dimension_home_b = ->
  if $('#home-b').length == 1 and $('#box-video-home').length == 1
    if $('#video-home_wrapper').length == 0 and $('#video-home_video_wrapper').length == 0 and $('#video-home').length > 0 and jwplayer('video-home') != null
      jwplayer('video-home').onReady ->
        set_height_video_home_b()
    else
      set_height_video_home_b()
    fix_label_home_b_position()

fix_label_home_b_position = ->
  if $('#home-b').length == 1 and $('#box-video-home').length == 1
    if $(window).width() <= 402
      _right = Math.floor $('#numbers_and_facts').outerWidth()/2
      $('#numbers_and_facts').css 'marginRight', "-#{_right}px"
    else
      $('#numbers_and_facts').removeAttr 'style'

# Fix proporzioni video pagina associazione-protetta
fix_video_dimension_associazione_protetta = ->
  if $('#protected-organization .box-video .video').length > 0
    ratio = 1.78
    new_height = $('#protected-organization .box-video .video').width() / ratio
    $('#protected-organization .box-video .video').css 'height', new_height

testFlash = ->
  support = false
  if "ActiveXObject" in window
    try
      support = !!(new ActiveXObject("ShockwaveFlash.ShockwaveFlash"))
    catch e
      support = false
  else
    support = !!navigator.mimeTypes['application/x-shockwave-flash']
  return support

# Fix proporzioni video pagina corsu
fix_video_dimension_corsi = ->
  iframe_video = $('#content-page-corsi .left iframe')
  if iframe_video.length > 0
    ratio = 1.78
    new_height = parseInt(iframe_video.width() / ratio, 10)
    iframe_video.css 'height', new_height

scrollTo = (element, to, duration)->
  return if duration <= 0
  difference = to - element.scrollTop()
  perTick = difference / duration * 2
  setTimeout ->
    element.scrollTop(element.scrollTop() + perTick)
    scrollTo(element, to, duration - 2)
  , 10

submitIubendaForm = (j_form)->
  subject_id = j_form.find("input[data-cons-id]").val()
  _iub.cons.submit
    form:
      selector: j_form[0] # il selettore del form da cui rilevare i dati
    consent:
      subject:
        id: subject_id
      legal_notices: [
        "identifier": "privacy_policy"
        "version": "2"
      ]
  .success (response)->
    # callback success
    console.log 'Success iubenda'
    console.log arguments
    $.ajax
      url: '/wp-content/plugins/request_api_demo.php'
      type: 'POST'
      data:
        api_url: window.demo_url+"api/iubenda/update_subject"
        email: subject_id
        email_confirmation: ''
      complete: ->
        console.log arguments
        j_form.trigger('ta:iubenda_success')
  .error (response)->
    # callback error
    console.log 'Error iubenda'
    console.log arguments
    j_form.trigger('ta:iubenda_error')

# Genera un object con i parametri in get - Object {chiave: "valore", chiave: "valore"}
window.params_get = {}
if window.location.search != ""
  string_params_get = window.location.search.replace("?","")
  if string_params_get.match(/&/)
    string_params_get = string_params_get.replace(/&/g,"=")
  split_params_get = string_params_get.split("=")
  $.each split_params_get, (i,param)->
    if not ((i/2)+"").match(/\./) or (i/2)==0
      window.params_get[param] = split_params_get[i+1]
    else return

$ ->

  flash_class_html = if testFlash() then 'flash' else 'no-flash'
  $('html').addClass flash_class_html

  tracker()
  bc = $('.nav-slideshow')
  move_submenu()

  # Autocomplete per chrome
  if $.browser and $.browser.chrome
    $('input[autocomplete="off"]').each ->
      $(@).attr("autocomplete", "chromenonrompere")

  # refresh Carousel
  refreshCarousel("true")

  # Carousel
  $("[data-gencarousel='true']").each ->
    $(@).gencarousel()

  if $('#slideshow').length > 0
    $container = $('#slideshow').cycle
      fx: 'fade'
      speed: 100
      timeout: 6000
      pause: 1
      slideExpr: '.slideshow-inner'
      height: '418px'
      after: ->
        $('.nav-slideshow a').removeClass('activeSlide')
        $('#slideshow').children().each ()->
          if $(this).css('opacity')==1
            nSlide = $(this).attr('rel')
            $('.slide-'+nSlide).addClass("activeSlide")

    $container.children().each (i)->
      $(this).attr('rel',(i+1))
      active = ""
      if $(this).css('opacity')==1
        active="activeSlide"
      $('<a href="#" class="'+active+' slide-'+(i+1)+'"></a>').appendTo(bc).on "click", ()->
        $container.cycle(i)
        return false

  $(".fancybox-div").each ()->
    link = $(this).attr('href')
    $(this).fancybox
      type: 'inline'
      width: 516
      height: 441
      padding: 0
      helpers:
        overlay:
          css:
            backgroundColor: 'rgba(0,0,0,0.6)'
      beforeShow: ()->
        $(".fancybox-skin").css
          backgroundColor: "transparent"
          boxShadow: "none"
      onStart: ()->
        $(link).show()
      onClosed: ()->
        $(link).parent().hide()

  $('.no-touch .fancybox-media').fancybox
    width: 516
    height: 441
    padding: 0
    helpers:
      overlay:
        css:
          backgroundColor: 'rgba(0,0,0,0.6)'
      media: {}

  $("#link-top-home").fancybox
    width: 575
    height: 319
    padding: 10
    helpers:
      overlay:
        css:
          backgroundColor: 'rgba(0,0,0,0.6)'
      media: {}
    beforeShow: ()->
      $(".fancybox-wrap").css backgroundColor: "transparent"
      $(".fancybox-wrap > div").css background: "none #000"


  $('.dialog-price .close-dialog-price').on "click", ()->
    $.fancybox.close()

  #$('.box-message-home').on "click", ()->
  #  document.location = $(this).attr('data-href')


  ##################### Nuova form a due campi #####################
  #Check per la nuova form a due campi
  window.checkRequestDemoForm = (form)->
    ok = true
    email = $("#demo_request_account_email",form)
    denom = $("#demo_request_society_name",form)
    unless Validator.presence(denom)
      Validator.addError denom, "Devi compilare questo campo", {error_class: "error-home2", error_color: "#B81010", border_width: "2px"}
      ok = false
    else
      Validator.removeError denom, {error_class: "error-home2", normal_color: "#B7B7B7", remove: false, border_width: "2px"}
    unless Validator.format(email,Validator.email_regexp)
      Validator.addError email, "Email non vailda", {error_class: "error-home2", error_color: "#B81010", border_width: "2px"}
      ok = false
    else
      Validator.removeError email, {error_class: "error-home2", normal_color: "#B7B7B7", remove: false, border_width: "2px"}
    return ok

  if $(".request_demo_form").length > 0
    $(".request_demo_form").each ()->
      el = $(this)
      email = $('.demo_request_account_email', el)
      denom = $('.demo_request_society_name', el)
      unless $.browser.msie
        if el.parents(".box-prova-why").hasClass("top") or (el.parent(".box-prova-top").length>0 and not el.parent(".box-prova-top").hasClass("bottom")) or el.parents(".box-prova-tour").hasClass("top") or el.parents("#associations").length>0 or el.parents("#box-contacts-new").length>0 or el.parents("#box-contacts").length>0 or el.parents("#box-request-demo-home").length>0 or el.parents("#box-prova-home2").length>0 or el.parent().find(".tooltip-request-demo").length>0
          denom.focus()
      if $.browser.msie
        email.on "focus", ()->
          if $(this).val()=="E-mail"
            $(this).val('')
        email.on "blur", ()->
          if $(this).val()==""
            $(this).val('E-mail')
        denom.on "focus", ()->
          if $(this).val()=="Nome associazione"
            $(this).val('')
        denom.on "blur", ()->
          if $(this).val()==""
            $(this).val('Nome associazione')
      else
        email.val ""
        denom.val ""

  $("#dialog-request-demo").dialog $.extend window.default_dialog_options,
    title: "Email già utilizzata"
    buttons:
      'Entra nella tua demo': ->
        document.location.href = "/ta_login"
        show_overlay()

  #'Richiedi nuova demo': ()->
  #  $(".request_demo_form").data "resend","true"
  #  $(".request_demo_form").submit()
  #  $(@).dialog('close')
  #  show_overlay()

  $(".request_demo_form").on "submit", (event)->
    if $(@).find('#email_confirmation').val() != ""
      event.preventDefault()
      hide_overlay()
      return
    unless checkRequestDemoForm $(@)
      event.preventDefault()
      $(@).data().resend = "false"
    else
      unless $(@).data().resend=="true"
        email = $('.demo_request_account_email', @)
        $.ajax
          url: $(@).data().checkEmailUrl
          dataType: 'json'
          async: false
          crossDomain: true
          data: {account_email: email.val()}
          success: ->
            event.preventDefault()
            $("#dialog-request-demo").dialog "open"
            #unless confirm("Hai già provato a richedere una demo. Se vuoi rechiederne un'altra clicca su 'OK', altrimenti clicca su 'Annulla' per effettuare il login")
            #  event.preventDefault()
            #  document.location.href = "/ta_login"
          error: ->
            show_overlay()
  ##################### Nuova form a due campi #####################

  # Request demo why-teamartist-page
  if $(".new_demo_request_why").length>0
    $(".new_demo_request_why").each ()->
      el = $(this)
      email = el.find('.demo_request_account_email')
      name = el.find('.demo_request_account_name')
      surname = el.find('.demo_request_account_surname')
      cell = el.find('.demo_request_account_mobile')
      denom = el.find('.demo_request_society_name')
      if el.parents(".box-prova-why").hasClass("top") or (el.parent(".box-prova-top").length>0 and not el.parent(".box-prova-top").hasClass("bottom")) or el.parents(".box-prova-tour").hasClass("top") or el.parents("#associations").length>0 or el.parents("#box-contacts-new").length>0 or el.parents("#box-contacts").length>0
        name.focus()
      if $.browser.msie
        email.on "focus", ()->
          if $(this).val()=="E-mail"
            $(this).val('')
        email.on "blur", ()->
          if $(this).val()==""
            $(this).val('E-mail')
        name.on "focus", ()->
          if $(this).val()=="Il tuo nome"
            $(this).val('')
        name.on "blur", ()->
          if $(this).val()==""
            $(this).val('Il tuo nome')
        surname.on "focus", ()->
          if $(this).val()=="Il tuo cognome"
            $(this).val('')
        surname.on "blur", ()->
          if $(this).val()==""
            $(this).val('Il tuo cognome')
        cell.on "focus", ()->
          if $(this).val()=="Cellulare"
            $(this).val('')
        cell.on "blur", ()->
          if $(this).val()==""
            $(this).val('Cellulare')
        denom.on "focus", ()->
          if $(this).val()=="Nome associazione"
            $(this).val('')
        denom.on "blur", ()->
          if $(this).val()==""
            $(this).val('Nome associazione')
      else
        email.val ""
        name.val ""
        surname.val ""
        cell.val ""
        denom.val ""


    $('.send_demo_request').each ()->
      $(this).on "click", ()->
        el = $(this)
        sendRequest(el)
  # end request why-teamartist tour-page

  # start request demo home2
  if $("#content").children().attr("id")=="home2"
    email = $('#demo_request_account_email')
    name = $('#demo_request_account_name')
    surname = $('#demo_request_account_surname')
    cell = $('#demo_request_account_mobile')
    denom = $('#demo_request_society_name')
    name.focus()
    if $.browser.msie
      email.on "focus", ()->
        if $(this).val()=="E-mail"
          $(this).val('')
      email.on "blur", ()->
        if $(this).val()==""
          $(this).val('E-mail')
      name.on "focus", ()->
        if $(this).val()=="Il tuo nome"
          $(this).val('')
      name.on "blur", ()->
        if $(this).val()==""
          $(this).val('Il tuo nome')
      surname.on "focus", ()->
        if $(this).val()=="Il tuo cognome"
          $(this).val('')
      surname.on "blur", ()->
        if $(this).val()==""
          $(this).val('Il tuo cognome')
      cell.on "focus", ()->
        if $(this).val()=="Cellulare"
          $(this).val('')
      cell.on "blur", ()->
        if $(this).val()==""
          $(this).val('Cellulare')
      denom.on "focus", ()->
        if $(this).val()=="Nome associazione"
          $(this).val('')
      denom.on "blur", ()->
        if $(this).val()==""
          $(this).val('Nome associazione')
    else
      email.val ""
      name.val ""
      surname.val ""
      cell.val ""
      denom.val ""

    $('#send_demo_request').on "click", ()->
      sendRequestHome()
    $("#scroll-header").css("background","none rgba(0,0,0,0.9)").css("filter","progid:DXImageTransform.Microsoft.gradient(startColorstr=#90000000,endColorstr=#90000000)")
  # end request demo home2

  # if $('.fancybox-div[href="#box-fancy-map"]').length>0
  #   $('.fancybox-div').on "click", ()->
  #     inizializeMapContacts()

  # if $("#box-request-demo").length>0
  #   $("#new_demo_request").on "submit", (event)->
  #     unless sendRequestDemo()
  #       event.preventDefault()

  if $('#send_demo_extended').length>0
    $('#send_demo_extended').on "click", ()->
      sendRequestExtended()

  if $("#tooltip").length>0
    setTimeout ()->
      $("#tooltip").css "overflow","visible"
      $("#tooltip").animate {height:42}, 500, ()->
        $("#tooltip span").show()
    ,1500

  $("#tabs-home li").each ()->
    el_li = $(this)
    el_li.find("a").on "click", (event)->
      event.preventDefault()
      show_id = $(this).attr("href")
      $("#tabs-home li").removeClass("selected")
      el_li.addClass("selected")
      if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "home-english-test"
        if el_li.hasClass("left")
          $("#tabs-home li.middle a").css("borderLeftColor", "transparent")
          $("#tabs-home li.middle a").css("borderRightColor", "#C1C1C1")
        else if el_li.hasClass("right")
          $("#tabs-home li.middle a").css("borderRightColor", "transparent")
          $("#tabs-home li.middle a").css("borderLeftColor", "#C1C1C1")
        else if el_li.hasClass("middle")
          $("#tabs-home li.middle a").css("borderColor", "transparent")
      $("#tabs-home-content").children("div").fadeOut(200)
      setTimeout ()->
        $(show_id).fadeIn(200)
      , 200

  $('.open-submenu').on "click", (event)->
    event.preventDefault();
    child = $("##{$(@).attr("rel")}")
    if $(window).width() < 831
      header_width = $("#header").outerWidth()
      child.css("width", "#{header_width}px")
      $("#menu-top-small").trigger "click"
    else
      _w = if child.attr('id') == 'menu-software' then '200px' else '190px'
      _w = '310px' if child.attr('id') == 'menu-blog'
      child.css("width", _w)
    add_close_submenu($(@).attr("rel"))
    close_submenus()
    unless child.is(":visible")
      child.slideDown(250)
    else
      child.slideUp(250)

  $("#box-bottom a").on "click", ()->
    $(".demo_request_society_name").focus()
    $("#tooltip").css "height","0"
    $("#tooltip").css "overflow","hidden"
    $("#tooltip span").hide()
    setTimeout ()->
      $("#tooltip").css "overflow","visible"
      $("#tooltip").animate {height: 42}, 500, ()->
        $("#tooltip span").show()
    ,500

  if $(".tooltip-request-demo").length>0
    setTimeout ()->
      $(".tooltip-request-demo").css "overflow","visible"
      $(".tooltip-request-demo").animate {height: 28}, 500, ()->
        $(".tooltip-request-demo span").css "display","block"
    , 300

  $("#associations").find("a[href='#']").on "click", (event)->
    event.preventDefault()

  # $(".copy-button").zclip
  #   path: "/wp-content/themes/teamartist/swf/zero_clipboard.swf"
  #   copy: ()->
  #     return $(this).data().url
  #   afterCopy: ()->
  #     alert $(this).data().text

  $(".copy-button").addClass('clipboard')
  clipboard = new ClipboardJS '.copy-button', {
    text: (trigger)->
      trigger.getAttribute('data-url')
  }
  clipboard.on 'success', (e)->
    alert e.trigger.getAttribute('data-text')

  $("#zd-form").find("input[type='text'], input[type='email'], input[type='number'], select").on "focusout", ()->
    el_input = $(@)
    if el_input.attr("id") != "zd_phone" and el_input.attr('id') != 'zd_email_confirmation'
      if el_input.attr("id") == "zd_email"
        unless Validator.format(el_input, Validator.email_regexp)
          msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Email is invalid" else "Email non vailda"
          Validator.addError el_input, msg
          ok = false
        else
          Validator.removeError el_input
      else
        unless Validator.presence(el_input)
          msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Can't be blank" else "Devi compilare questo campo"
          Validator.addError el_input, msg
        else
          Validator.removeError el_input

  $("#zd-form").find("textarea").on "focusout", ()->
    el_textarea = $(@)
    unless Validator.presence(el_textarea)
      msg = if $("body").data().pageTitle != undefined and $("body").data().pageTitle == "contacts-english-test" then "Can't be blank" else "Devi compilare questo campo"
      Validator.addError el_textarea, msg
    else
      Validator.removeError el_textarea

  $("#zd-form").find("input[type=checkbox]").on "change", ()->
    trattamento = $(this)
    if !trattamento.is(':checked')
      trattamento.parent().children('div').show()
    else
      trattamento.parent().children('div').hide()

  $("#zd-form").on "submit", (event)->
    form = $(@)
    if not checkFormContacts()
      event.preventDefault()
    else if form.hasClass('iubenda')
      submitIubendaForm(form)

  $("#box-pricing #pricing table tr td a[href='#']").on "click", (event)->
    event.preventDefault()

  # Funzioni per mappa nei contatti
  map_wrapper = $('#map_wrapper');
  if map_wrapper.length > 0
    getLatLong map_wrapper.data().address, initialize
    $('#get-directions-submit').on "click",()->
      calcRoute()

  dialog_send_zendesk = $("#dialog-send-zendesk")
  if dialog_send_zendesk.length > 0
    $("[data-create-zendesk=true]").on 'click', (event)->
      event.preventDefault()
      link = $(@)
      dialog_send_zendesk.load link.attr('href'), link.data(), ->
        $('#form_send_zendesk').on 'submit', (e)->
          if($('#zd_email').val().length > 0 && Validator.email_regexp.test($('#zd_email').val()))
            dialog_send_zendesk.dialog('close')
          else
            e.preventDefault()
        dialog_send_zendesk.dialog $.extend window.default_dialog_options,
          title: "Inserisci i tuoi dati"
          autoOpen: true
          buttons: [
            {
              text: "Richiedi"
              class: 'submit'
              click: ->
                $(@).find("form").trigger "submit"
            }, {
              text: "Annulla"
              class: 'left'
              click: ->
                $(this).dialog "close"
            }
          ],
          close: ->
            dialog_send_zendesk.dialog 'destroy'

  if $("#accountant-page").length == 1
    $(".box-confronta form").on "submit", (event)->
      event.preventDefault()
      form = $(@)
      piva = form.find("#piva").val()
      sei398 = form.find("#sei398").val()
      staff = form.find("#staff").val()
      form.find("select").each ->
        if $(@).val() == ""
          $(@).parent().addClass("error")
        else
          $(@).parent().removeClass("error")
      $(".box-confronta .right > div > div").hide()
      if form.find(".error").length == 0
        if sei398 == "no" and piva == "no" and staff == "0"
          $(".box-confronta .right > div > div.base").show()
        else if sei398 == "no" and piva == "no" and staff == "<=10"
          $(".box-confronta .right > div > div.pro").show()
        else if sei398 == "yes" and piva == "yes" and staff == ">10"
          $(".box-confronta .right > div > div.all_inclusive").show()
        else if sei398 == "yes" and piva == "yes" and staff != ">10"
          $(".box-confronta .right > div > div.super").show()
        else
          $(".box-confronta .right > div > div.not-available").show()
      else
        $(".box-confronta .right > div > div.missing-fields").show()

    $(".box-bottom .details").on "click", (event)->
      event.preventDefault()
      $("#wrap-table-details").toggle()

    if params_get? and params_get.error == "true"
      alert "Si è verificato un errore nell'inoltrare la tua richiesta. Ti preghiamo di riprovare più tardi, grazie."

    $("#open-dialog-more-info-services").on "click", (event)->
      event.preventDefault()
      $("#dialog-more-info-services").dialog $.extend window.default_dialog_options,
        title: "Inserisci i tuoi dati"
        autoOpen: true
        buttons: [
          {
            text: "Richiedi"
            "class": 'submit'
            click: ->
              $(@).find("form").trigger "submit"
          }, {
            text: "Annulla"
            "class": 'left'
            click: ->
              $(@).dialog "close"
          }
        ]
        close: ->
          $(@).find('#zd_description').val $(@).find('#zd_description').data("value")
          $(@).find('#zd_subject').val $(@).find('#zd_subject').data("value")
          $(@).find("#zd_name").val ""
          $(@).find("#zd_email").val ""

    if $("#dialog-thanks").length == 1
      $("#dialog-thanks").dialog $.extend window.default_dialog_options,
        title: 'Grazie'
        autoOpen: true
        buttons:
          "Chiudi": ->
            $(@).dialog "close"

      $("#dialog-thanks a").on "click", ->
        $(@).parents("#dialog-thanks").dialog "close"

    $(".send-zendesk").on "click", (event)->
      event.preventDefault()
      $("#form-fiscal-services").data("service", $(@).data("service"))
      $("#open-dialog-more-info-services").trigger "click"

    $("#form-fiscal-services").on "submit", (event)->
      form = $(@)
      name = form.find("#zd_name")
      email = form.find("#zd_email")
      service = form.data("service")
      if($.trim(name.val()) == "" or !Validator.email_regexp.test($.trim(email.val())))
        event.preventDefault()
        alert("Compila tutti i campi!")
      else
        show_overlay()
        subject = $("#zd_subject")
        _subject = $("#zd_subject").val()
        _new_subject = _subject.replace("[:zd_name:]", name.val())
        $("#zd_subject").val _new_subject
        description = $("#zd_description")
        _description = $("#zd_description").val()
        _new_description = _description.replace("[:zd_name:]", name.val()).replace("[:zd_email:]", email.val()).replace("[:service:]", service)
        $("#zd_description").val _new_description

  # Menu mobile
  $("#menu-top-small").on "click", ->
    close_submenus()
    menu = $("#menu-top")
    if menu.is(":visible")
      menu.slideUp(250)
    else
      menu.slideDown(250)

  # Ricalcolo dimensioni sottomenu Associazioni
  header_width = $("#header").outerWidth()
  $("#menu-ass").css("width", "#{header_width}px")
  $("#link-menu-ass").on "click", (event)->
    event.preventDefault()
    menu_ass = $("#menu-ass")
    if menu_ass.length > 0
      unless menu_ass.is(":visible")
        close_submenus()
        menu_ass.slideDown(250)
        if $(window).width() <= 790
          $("body").css("overflow", "hidden")
      else
        menu_ass.slideUp(250)
        $("body").css("overflow", "initial")

  # Chiusura sottomenu Associazioni
  $(document).on "click", ".close-submenu a", (event)->
    event.preventDefault()
    link_trigger = $(@).parent().attr("rel")
    $("##{link_trigger}").trigger "click"

  if $(".tooltip-new").length>0
    setTimeout ()->
      $(".tooltip-new").css "overflow","visible"
      $(".tooltip-new").animate {height: 28}, 500, ()->
        $(".tooltip-new span").css "display","block"
    ,300

  $("#box-pricing #pricing .line a").on "click", (event)->
    event.preventDefault()
  # Visualizzazione dettagli pacchetti con width < 751
  $("#box-pricing #pricing .line.last-mobile a").on "click", (event)->
    event.preventDefault()
    link = $(@)
    content = link.parent().prev(".content-lines")
    if link.hasClass("show")
      content.animate
        height: 0
      , 300
      , ->
        link.removeClass "show"
        link.text link.data().show
    else
      show_lines = content.find(".line:not(.empty)").length
      content.animate
        height: (show_lines*43)
      , 300
      , ->
        link.addClass "show"
        link.text link.data().hide

  $("#other_services").on "click", (event)->
    event.preventDefault()
    other_services = $("#other-services")
    if other_services.is(":visible")
      $("#other-services").slideUp()
    else
      $("#other-services").slideDown()

  # Sticky footer
  sticky_footer()

  fix_label_home_b_position()

  # Check form per richiedere appuntamento
  $(".appointment-form").find("input[type='text'], input[type='email'], input[type='number']").on "focusout", ()->
    el_input = $(@)
    return if el_input.attr('name') == 'email_confirmation'
    if el_input.attr("type") == "email"
      unless Validator.format(el_input, Validator.email_regexp)
        msg = if $("html").attr('lang') != 'it-IT' then "Email is invalid" else "Email non vailda"
        Validator.addError el_input, msg
        ok = false
      else
        Validator.removeError el_input
    else
      unless Validator.presence(el_input)
        msg = if $("html").attr('lang') != 'it-IT' then "Can't be blank" else "Devi compilare questo campo"
        Validator.addError el_input, msg
      else
        Validator.removeError el_input

  $(".appointment-form").find("input[type='checkbox']").on "change", ()->
    el_input = $(@)
    unless Validator.presence(el_input)
      msg = if $("html").attr('lang') != 'it-IT' then "Flag this box" else "Spunta questa casella"
      Validator.addError el_input, msg
    else
      Validator.removeError el_input

  $('#hidden-zd-form').on 'submit', (event)->
    event.preventDefault()

  $(".appointment-form").on "submit", (event)->
    appointment_form = $(@)
    if not checkFormAppointment(appointment_form)
      event.preventDefault()
    else
      unless appointment_form.data().sendZendesk == true
        event.preventDefault()
        submitIubendaForm(appointment_form) if appointment_form.hasClass('iubenda')
        zd_form = $('#hidden-zd-form')
        tag = zd_form.find('input[name="zd_tag[]"]')
        tag_name = if tag.length > 0 then tag.val() else null
        if $('html').data().env == 'development' and tag_name != 'Contatti' # NOTE: Se sono in locale e il tag non è Contatti skippo l'invio dello zendesk
          appointment_form.data().sendZendesk = true
          if appointment_form.data().submitParams == 1
            appointment_form.trigger 'submit'
          else
            document.location = appointment_form.attr('action')
        else
          $('#overlay').show()
          name = appointment_form.find('.appointment-name').val()
          surname = appointment_form.find('.appointment-surname').val()
          email = appointment_form.find('.appointment-email').val()
          phone = if appointment_form.find('.appointment-mobile-phone').length > 0 then appointment_form.find('.appointment-mobile-phone').val() else ''
          service = $('#hidden-zd-form #zd_description').data().service
          subject = $('#hidden-zd-form #zd_subject').data().value
          $('#hidden-zd-form #zd_name').val "#{name} #{surname}"
          $('#hidden-zd-form #zd_email').val email
          $('#hidden-zd-form #zd_phone').val phone
          $('#hidden-zd-form #zd_description').val "#{name} #{surname} ha richiesto un appuntamento telefonico per #{service} dalla pagina #{document.location.href} lasciando email, #{email}, e telefono, #{phone}"
          $('#hidden-zd-form #zd_subject').val "#{name} #{surname} #{subject}"
          account_name_field = $('#hidden-zd-form #account_name')
          if account_name_field.length == 0
            account_name_field = $('<input type="hidden" id="account_name" name="account_name" />')
            $('#hidden-zd-form').append(account_name_field)
          account_name_field.val(name)
          account_surname_field = $('#hidden-zd-form #account_surname')
          if account_surname_field.length == 0
            account_surname_field = $('<input type="hidden" id="account_surname" name="account_surname" />')
            $('#hidden-zd-form').append(account_surname_field)
          account_surname_field.val(surname)
          $.ajax
            url: zd_form.data().action
            type: 'POST'
            data: zd_form.serialize()
            dataType: 'json'
            complete: ->
              $('#hidden-zd-form #zd_subject').val $('#hidden-zd-form #zd_subject').data().value
            success: (data)->
              appointment_form.append "<input type='hidden' name='ticket_id' value='#{data.ticket.id}' />" if data.ticket?
              appointment_form.append "<input type='hidden' name='start_lead_email' value='#{data.lead_email}' />" if data.lead_email?
              appointment_form.data().sendZendesk = true
              if appointment_form.data().submitParams == 1
                appointment_form.trigger 'submit'
              else
                document.location = appointment_form.attr('action')
            error: ->
              $('#overlay').hide()
              alert 'Si è verificato un errore. Riprova più tardi.'
  # Fine check form per richiedere appuntamento

  $('#show-other-testimonials').on 'click', (event)->
    event.preventDefault()
    $(@).parent().hide()
    $('#other-testimonials').slideDown(100*$('#other-testimonials .testimonial').length)

  # Fix proporzioni video pagina associazione-protetta
  fix_video_dimension_associazione_protetta()

  # Fix proporzioni video pagina corsi
  fix_video_dimension_corsi()

  # Pagina Testimonials
  if $('body#page-testimonials').length == 1
    $('#client_kind').on 'change', ->
      _form = $(@).parents('form')
      switch $(@).val()
        when ''
          _form.find('#client_sport, #client_activity').val('')
          _form.find('#client_sport, #client_activity').hide()
        when 's'
          _form.find('#client_activity').val('')
          _form.find('#client_activity').hide()
          _form.find('#client_sport').show()
        when 'n'
          _form.find('#client_sport').val('')
          _form.find('#client_sport').hide()
          _form.find('#client_activity').show()

    $('#complete-search-dialog *[data-action="close-dialog"]').on 'click', (event)->
      event.preventDefault()
      $('#complete-search-dialog, #overlay').fadeOut()

    $('#complete-search-dialog #client_kind_d').on 'change', ->
      _form = $(@).parents('form')
      switch $(@).val()
        when ''
          _form.find('#field_client_sport, #field_client_activity').val('')
          _form.find('#field_client_sport, #field_client_activity').hide()
        when 's'
          _form.find('#field_client_activity').val('')
          _form.find('#field_client_activity').hide()
          _form.find('#field_client_sport').show()
        when 'n'
          _form.find('#field_client_sport').val('')
          _form.find('#field_client_sport').hide()
          _form.find('#field_client_activity').show()

  if $(".arrow-bounce").length == 1
    setTimeout ->
      $(".arrow-bounce").show()
    , 2200

  if $('form#download-file-create-society').length > 0
    # Setto il device usato per i Lead
    if typeof WURFL == "undefined"
      script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = (if 'https:' == document.location.protocol then 'https://' else 'http://') + 'wurfl.io/wurfl.js'
      s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(script, s)
      window.interval_set_device = setInterval ->
        if typeof WURFL != "undefined"
          $('form#download-file-create-society').append '<input type="hidden" name="device" value="'+WURFL.form_factor+'" />'
          clearInterval window.interval_set_device
      , 1000
    else
      $('form#download-file-create-society').append '<input type="hidden" name="device" value="'+WURFL.form_factor+'" />'

    $('form#download-file-create-society input[name="trattamento"]').on 'change', ->
      if $(@).is(':checked')
        $(@).parent().removeClass('error')
      else
        $(@).parent().addClass('error')

    $('form#download-file-create-society input[name="email"]').on 'change focusout', ->
      unless Validator.email_regexp.test($(@).val())
        $(@).parent().addClass('error')
      else
        $(@).parent().removeClass('error')

    $('form#download-file-create-society').on 'submit', (event)->
      event.preventDefault()
      form = $(@)
      form.find('input[name="trattamento"]').trigger('change')
      form.find('input[name="email"]').trigger('change')
      ok = form.find('.field.error').length == 0
      if ok and form.find('input[name="email_confirmation"]').val() == ""
        $('#overlay').show()
        $.ajax
          url: form.data('api')
          type: 'POST'
          data: form.serialize()
          success: ->
            submitIubendaForm(form) if form.hasClass('iubenda')
            if form.data().redirect
              document.location = form.data().redirect
            else
              alert "A breve riceverai un'email con la guida in allegato. Se non vedi la risposta nella tua casella email controlla anche nello spam."
              form.find('input[name="email"]').val('')
              form.find("input[type='checkbox']").prop('checked', false)
              $('#overlay').hide()
          error: ->
            alert "Si è verificato un errore. Si prega di riprovare più tardi."
            $('#overlay').hide()

  if $('form#form-controllo').length > 0
    device_field = $('form#form-controllo input[name="lead[device]"]')
    # Setto il device usato per i Lead
    if typeof WURFL == "undefined"
      script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = (if 'https:' == document.location.protocol then 'https://' else 'http://') + 'wurfl.io/wurfl.js'
      s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(script, s)
      window.interval_set_device = setInterval ->
        if typeof WURFL != "undefined"
          if device_field.length > 0
            device_field.val WURFL.form_factor
          else
            $('form#form-controllo').append '<input type="hidden" name="lead[device]" value="'+WURFL.form_factor+'" />'
          clearInterval window.interval_set_device
      , 1000
    else
      if device_field.length > 0
        device_field.val WURFL.form_factor
      else
        $('form#form-controllo').append '<input type="hidden" name="lead[device]" value="'+WURFL.form_factor+'" />'

    $('form#form-controllo input[name="trattamento"]').on 'change', ->
      if $(@).is(':checked')
        $(@).parent().removeClass('error')
      else
        $(@).parent().addClass('error')

    $('form#form-controllo input[name="lead[email]"]').on 'change focusout', ->
      unless Validator.email_regexp.test($(@).val())
        $(@).parent().addClass('error')
      else
        $(@).parent().removeClass('error')

    $('form#form-controllo select[name="slug"]').on 'change focusout', ->
      if $(@).val() == ''
        $(@).parents('.field').addClass('error')
      else
        $(@).parents('.field').removeClass('error')

    $('form#form-controllo').on 'submit', (event)->
      event.preventDefault()
      form = $(@)
      form.find('input[name="trattamento"]').trigger('change')
      form.find('input[name="lead[email]"]').trigger('change')
      form.find('select[name="slug"]').trigger('change')
      ok = form.find('.field.error').length == 0
      if ok and form.find('input[name="lead[email_confirmation]"]').val() == ""
        $('#overlay').show()
        $.ajax
          url: form.data('api')
          type: 'POST'
          data: form.serialize()
          success: ->
            submitIubendaForm(form) if form.hasClass('iubenda')
            if form.data().redirect
              document.location = form.data().redirect
            else
              alert "A breve riceverai un'email con la guida in allegato. Se non vedi la risposta nella tua casella email controlla anche nello spam."
              form.find('input[name="email"]').val('')
              form.find("input[type='checkbox']").prop('checked', false)
              $('#overlay').hide()
          error: ->
            alert "Si è verificato un errore. Si prega di riprovare più tardi."
            $('#overlay').hide()

  if $('#hp-310516').length > 0
    $('#hp-310516 #bottom .wrap > div .text > a').on 'click', (event)->
      event.preventDefault()
      $($(@).attr('href')).fadeIn 'slow', ->
        $('body').css 'overflow', 'hidden'

    $('.dialog-hp .ion-close').on 'click', (event)->
      event.preventDefault()
      $(@).parents('.dialog-hp').fadeOut 'slow', ->
        $('body').css 'overflow', ''

    if $('#download-file-create-society').length > 0
      $('#download-file-create-society input[name="email"]').focus()

  # MAPPA SU PAGINA TESTIMONIANZE
  if $('body#page-opinioni-su-teamartist').length > 0
    myOptions = { zoom: 5, center: new google.maps.LatLng(42.35, 12.4), mapTypeId: 'roadmap' }
    map = new google.maps.Map($('#map_canvas')[0], myOptions)

    google.maps.event.addDomListener window, 'resize', ->
      map.setCenter(new google.maps.LatLng(42.35, 12.4))

    $.ajax
      url: '/wp-content/plugins/request_api_demo.php'
      method: 'POST'
      data: { list_for_maps: 'coords' }
    .done (msg)->
      coords = eval(msg)
      for x in [0..(coords.length-1)]
        latlng = new google.maps.LatLng(coords[x][0], coords[x][1])
        new google.maps.Marker({position: latlng, map: map})

  $('#teamartist-tour a.btn').on 'click', (event)->
    link = $(@)
    if link.attr('href') == '#'
      event.preventDefault()
      if link.hasClass('disabled')
        alert('Non ci si può più iscrivere a questo convegno')
      else
        alert('Non è ancora possibile iscriversi a questo convegno')

  if $('body#page-thanks-teamartist-tour-2017').length > 0
    if fbq? and params_get.amount? and params_get.currency?
      fbq('track', 'Purchase', {value: params_get.amount, currency: params_get.currency})
      document.location = "/thanks-teamartist-tour-2017/"

  if $('body#page-thanks-teamartist-tour-2018').length > 0
    if fbq? and params_get.amount? and params_get.currency?
      fbq('track', 'Purchase', {value: params_get.amount, currency: params_get.currency})
      document.location = "/thanks-teamartist-tour-2018/"

  if $('#dati-superdirigente').length > 0
    form = $('#dati-superdirigente form')
    form.on 'submit', (event)->
      event.preventDefault()
      error = false
      form.find('input[type="text"], input[type="number"], input[type="email"], select').each ->
        field = $(this)
        if field.attr('id') == 'email_confirmation' && field.val() != ''
          error = true
        else if field.attr('id') != 'email_confirmation' && field.val() == ''
          error = true
      trattamento = form.find('input[name="trattamento"]')
      error = true unless trattamento.is(':checked')
      if error
        alert('Controlla di aver inserito tutti i dati')
      else
        submitIubendaForm(form) if form.hasClass('iubenda')
        $.ajax
          url: form.attr('action')
          type: 'POST'
          data: form.serialize()
          beforeSend: ->
            $('#overlay').show()
          complete: ->
            alert("Stai per essere mandato sulla pagina di facebook dove potrai entrare a far parte del gruppo dei Superdirigenti.")
            if form.data().redirect
              document.location = form.data().redirect
            else
              document.location = 'https://www.facebook.com/groups/teamartist.italia/'

  if $("#task-software-information").length > 0
    form = $("#task-software-information")
    email = $('.email', form)
    mobile = $('.mobile_phone', form)
    account_name = $('.account_name', form)
    account_surname = $('.account_surname', form)
    trattamento = form.find('input[name="trattamento"]')
    if $.browser.msie
      email.on "focus", ->
        if $(this).val() == "E-mail"
          $(this).val('')
      email.on "blur", ->
        if $(this).val() == ""
          $(this).val('E-mail')
      mobile.on "focus", ->
        if $(this).val() == "Numero di cellulare"
          $(this).val('')
      mobile.on "blur", ->
        if $(this).val() == ""
          $(this).val('Numero di cellulare')
      account_name.on "focus", ->
        if $(this).val() == "Nome"
          $(this).val('')
      account_name.on "blur", ->
        if $(this).val() == ""
          $(this).val('Nome')
      account_surname.on "focus", ->
        if $(this).val() == "Cognome"
          $(this).val('')
      account_surname.on "blur", ->
        if $(this).val() == ""
          $(this).val('Cognome')
    else
      email.val ""
      mobile.val ""
      account_name.val ""
      account_surname.val ""

    # Setto il device usato per i Lead
    if typeof WURFL == "undefined"
      script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = (if 'https:' == document.location.protocol then 'https://' else 'http://') + 'wurfl.io/wurfl.js'
      s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(script, s)
      window.interval_set_device = setInterval ->
        if typeof WURFL != "undefined"
          form.find('input[name="lead[device]"]').val WURFL.form_factor
          clearInterval window.interval_set_device
      , 1000
    else
      form.find('input[name="lead[device]"]').val WURFL.form_factor

    form.on 'submit', (event)->
      event.preventDefault()
      ok = true
      if account_name.val() == "" || account_name.val() == "Numero di cellulare"
        account_name.css('border','2px solid #B81010')
        form.find('.error-account_name').show()
        ok = false
      else
        account_name.css('border','1px solid #B7B7B7')
        form.find('.error-account_name').hide()
      if account_surname.val() == "" || account_surname.val() == "Numero di cellulare"
        account_surname.css('border','2px solid #B81010')
        form.find('.error-account_surname').show()
        ok = false
      else
        account_surname.css('border','1px solid #B7B7B7')
        form.find('.error-account_surname').hide()
      if mobile.val() == "" || mobile.val() == "Numero di cellulare"
        mobile.css('border','2px solid #B81010')
        form.find('.error-mobile').show()
        ok = false
      else
        mobile.css('border','1px solid #B7B7B7')
        form.find('.error-mobile').hide()
      unless Validator.email_regexp.test(email.val())
        email.css('border','2px solid #B81010')
        form.find('.error-email').show()
        ok = false
      else
        email.css('border','1px solid #B7B7B7')
        form.find('.error-email').hide()
      if trattamento.length > 0
        if trattamento.is(':checked')
          trattamento.parent().removeClass('error')
        else
          ok = false
          trattamento.parent().addClass('error')
      email_confirmation = form.find("#email_confirmation")
      if Validator.presence(email_confirmation)
        ok = false
        alert 'Controlla i dati inseriti'
      if ok
        submitIubendaForm(form) if form.hasClass('iubenda')
        $.ajax
          url: form.data('api')
          type: 'POST'
          data: form.serialize()
          beforeSend: ->
            $('#overlay').show()
          success: ->
            alert("La tua richiesta è andata a buon fine. Nei prossimo giorni verrai ricontattato da uno dei nostri consulenti al numero di cellulare inserito")
            if form.data().redirect
              document.location = form.data().redirect
            else
              $('#overlay').hide()
          error: ->
            alert "Si è verificato un errore. Riprova più tardi"
            $('#overlay').hide()

  setTimeout ->
    if $('#TActb').length > 0
      window.tactb_limit_window_width = $('#TActb .top-bar-section ul.floatleft').outerWidth() + $('#TActb .top-bar-section ul.floatright').outerWidth()
      if $(window).width() < window.tactb_limit_window_width
        $('#TActb').addClass('small')
  , 200

  if $('body#page-doma-i-tuoi-soci-tour-date').length > 0 or $('body#page-doma-i-tuoi-soci-tour-date-2').length > 0
    $('#page2 a.btn').on 'click', (event)->
      event.preventDefault()
      el = if navigator.userAgent.toLowerCase().indexOf('firefox') != -1 then $('html') else $('body')
      el = $('html') if el.scrollTop() == 0
      scrollTo el, $('#anchor-dates').position().top, 100

  if $('#libro-page').length > 0
    $('#libro-page .bullet').on 'click', (event)->
      event.preventDefault()
      $('#libro-page .bullet').removeClass('current')
      $(@).addClass('current')
      $('#libro-page .images img').addClass('hidden')
      $("#libro-page .images ##{$(@).data().ref}").removeClass('hidden')

  if $('#landingpage-tutelo').length > 0 or $('#page-organizzo').length > 0 or $('#page-organizzo-new').length > 0
    $('#video-links a').on 'click', (event)->
      event.preventDefault()
      $('#video-links a').removeClass('selected')
      $(@).addClass('selected')
      idx = $(@).index()
      $('#content-videos > div').addClass('hidden')
      $("#content-videos > div:nth-child(#{idx+1})").removeClass('hidden')

  if $('#page-organizzo').length > 0 or $('#page-organizzo-new').length > 0
    # Lista di attesa che genera un ticket a Tom
    $(".buy-now[href='#']").on "click", (event)->
      event.preventDefault()
      $("#dialog-lista-attesa").dialog $.extend window.default_dialog_options,
        title: "Inserisci i tuoi dati per entrare nella lista d'attesa"
        autoOpen: true
        buttons: [
          {
            text: "Richiedi"
            "class": 'submit'
            click: ->
              $(@).find("form").trigger "submit"
          }, {
            text: "Annulla"
            "class": 'left'
            click: ->
              $(@).dialog "close"
          }
        ]
        close: ->
          $(@).find("#zd_name").val ""
          $(@).find("#zd_surname").val ""
          $(@).find("#zd_email").val ""

    $(document).on 'submit', '#send-ticket', (event)->
      form = $(@)
      if form.find('#zd_name').val() == '' or form.find('#zd_surname').val() == '' or form.find('#zd_mobile_phone').val() == '' or !Validator.email_regexp.test(form.find('#zd_email').val())
        event.preventDefault()
        alert("Tutti i campi sono obbligatori. Controlla di averli inseriti tutti correttamente e riprova")
      else
        $("#overlay").show()

    if params_get.zd_name?
      alert("#{params_get.zd_name} la tua richiesta è stata inviata correttamente.")

  $('#banner-info-bottom .close').on 'click', (event)->
    event.preventDefault()
    $(@).parents('#banner-info-bottom').animate
      bottom: "-100px"
    , 3000

  $('.countdown-js').each ->
    el = $(@)
    el.countdown el.data().date, (event)->
      $(@).html event.strftime('%D giorni %H:%M:%S')

  if $('body#page-account-deletion').length > 0
    $('#account-deletion form').on 'submit', (event)->
      event.preventDefault()
      form = $(@)
      $("#overlay").show()
      $.ajax
        type: 'POST'
        url: form.attr('action')
        data: form.serialize()
        complete: (xhr)->
          $("#overlay").hide()
        success: ->
          alert form.data().ok
          form.find('textarea').val('')
        error: ->
          alert form.data().ko
# FINE READY

# Nuova form commenti che passa da DEMO
$ ->
  if $('#demo_commentform[data-comment-sent="yes"]').length > 0
    alert('Commento inviato con successo!')
    url = remove_params_from_url(window.location.href, ['comment-sent'])
    document.location = url

  arr_phone1 = ["", ".", '390000000000', "000000000", "0000000000", "0000000000000", "1111", "11111", "111111111", "123123123", "123", "1234", "12345", "123456", "1234567", "123456778", "12345678", "123456789", "1234567890", "1234567899", "123456798", "222222222", "1234567891", "1324343123", "1787012", "213123123", "2323232323", "234234", "23456789", "39", "+39", "3213213213"]
  arr_phone2 = []
  $.each arr_phone1, (i,fmp)->
    arr_phone2.push "39"+fmp if $.inArray(fmp, ["",".","+39"]) == -1
  fake_mobile_phones = $.unique($.merge(arr_phone1,arr_phone2))

  $('#demo_commentform .field.required input').on 'change', ->
    phone_rg = /\+*([0-9\/\-\.\s]+){5,}/
    email_rg = /^([\w\.\-\+]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/
    if ($(@).attr('id') == 'email' and not email_rg.test($(@).val())) or ($(@).attr('id') == 'mobile_phone' and (not phone_rg.test($(@).val()) or $.inArray($(@).val(), fake_mobile_phones) >= 0)) or $(@).val() == ''
      $(@).parents('.field').addClass('error')
    else
      $(@).parents('.field').removeClass('error')

  $('#demo_commentform .field.required textarea').on 'change', ->
    _val = $(@).val()
    if _val == ''
      $(@).parents('.field').addClass('error')
    else
      $(@).parents('.field').removeClass('error')
      # if /.*https?:\/\//.test(_val)
      #   $(@).parents('.field').addClass('error')
      #   alert 'Non puoi inserire dei link nel commento!'
      # else
      #   $(@).parents('.field').removeClass('error')

  $('#demo_commentform').on 'submit', (event)->
    $(@).find('.field.required').each ->
      field = $(@).find('input')
      field = $(@).find('textarea') if field.length == 0
      field.trigger('change') if field.length > 0
    if $(@).find('.field.error').length > 0 or $(@).find('#email_confirmation').val() != ''
      event.preventDefault()
      alert 'Compila tutti i campi obbligatori!'
      # if $(@).find('.field.error #comment_content').length > 0 and $(@).find('.field.error #comment_content').val() != ''
      #   if $(@).find('.field.error').length == 1
      #     alert 'Non puoi inserire dei link nel commento!'
      #   else
      #     alert 'Non puoi inserire dei link nel commento!\nCompila tutti i campi obbligatori!'
      # else
      #   alert 'Compila tutti i campi obbligatori!'
# Fine nuova form commenti che passa da DEMO

$(window).load ()->
  agentMobileSystem = navigator.userAgent.toLowerCase()
  arrAgentMobileSystem = ['vnd.wap.xhtml+xml', 'sony', 'symbian', 'nokia', 'samsung', 'mobile', 'windows ce', 'epoc', 'opera mini', 'nitro', 'j2me', 'midp-', 'cldc-', 'netfront', 'mot', 'up.browser', 'up.link', 'audiovox', 'blackberry', 'ericsson', 'panasonic', 'philips', 'sanyo', 'sharp', 'sie-', 'portalmmm', 'blazer', 'avantgo', 'danger', 'palm', 'series60', 'palmsource', 'pocketpc', 'smartphone', 'rover', 'ipaq', 'au-mic', 'alcatel', 'ericy', 'vodafone', 'wap1', 'wap2', 'teleca', 'playstation', 'lge', 'lg-', 'iphone', 'android', 'htc', 'dream', 'webos', 'bolt', 'nintendo']
  for i in arrAgentMobileSystem
    if agentMobileSystem.indexOf(arrAgentMobileSystem[i]) != -1 && screen.width < 1280
      $('#scroll-header').css("position","static")
      $("body").css("position", "relative")
      $("#woopra_bar").attr("style","position:absolute;bottom:391px;right:70px;display:block;")

$(window).on 'resize', ->
  w_window = $(window).width()

  move_submenu()

  close_submenus(($('#menu-top-small').is(':visible') and $('#menu-top').is(':visible')), false)

  if w_window > 830
    $("#menu-top").removeAttr "style"

  # Fix overflow body per menu associazioni
  if w_window > 790 and $("body").css("overflow") == "hidden"
    $("body").css("overflow", "initial")
  else if w_window <= 790 and $("#menu-ass").is(':visible') and $("body").css("overflow") == "visible"
    $("body").css("overflow", "hidden")

  # Setto larghezza sottomenu Associazioni
  menu_ass = $("#menu-ass")
  if menu_ass.length > 0
    header_width = $("#header").outerWidth()
    menu_ass.css("width", "#{header_width}px")

  # Fix altezza contenitore linee dettagli pacchetti
  if $(".content-lines").length > 0
    if w_window > 750
      $(".content-lines").each ->
        link = if $(@).next(".last-mobile").length == 1 then $(@).next(".last-mobile").find("a") else null
        if link and link.hasClass("show")
          link.removeClass "show"
          link.text link.data().show
          $(@).removeAttr("style")
        else
          $(@).removeAttr("style")

  # fix posizione dialog
  if $(".ui-dialog:visible").length > 0
    $(".ui-dialog:visible").each ->
      fix_dialog_dimension($(@))

  # refresh Carousel
  refreshCarousel()

  # Sticky footer
  sticky_footer()

  # Fix dimensioni video nella pagina home-b
  if $('#video-home').length > 0
    fix_video_dimension_home_b()

  # Fix proporzioni video pagina associazione-protetta
  fix_video_dimension_associazione_protetta()

  # Fix proporzioni video pagina corsi
  fix_video_dimension_corsi()

  if $('#TActb').length > 0
    window.tactb_limit_window_width = $('#TActb .top-bar-section ul.floatleft').outerWidth() + $('#TActb .top-bar-section ul.floatright').outerWidth() unless window.tactb_limit_window_width?
    if w_window < window.tactb_limit_window_width
      $('#TActb').addClass('small')
    else
      $('#TActb').removeClass('small')

# Validazione form
checkForm = (form)->
  ok = true
  form.find('input[data-tavalidate="true"], select[data-tavalidate="true"]').each ->
    field = $(@)
    if field.attr('type') == 'email'
      unless Validator.format(field, Validator.email_regexp)
        Validator.addError field, "Email non vailda"
        ok = false
      else
        Validator.removeError field
    else
      unless Validator.presence(field)
        msg = if field.attr('type') == 'checkbox' then "Spunta questa casella" else "Devi compilare questo campo"
        Validator.addError field, msg
        ok = false
      else
        Validator.removeError field
    return
  return ok

$ ->
  $('form[data-tavalidate="true"]').each ->
    form = $(@)
    form.on 'submit', (event)->
      ok = checkForm(form)
      ok = (form.find('input[name="email_confirmation"]').length == 0 or form.find('input[name="email_confirmation"]').val() == "") if ok
      unless ok
        event.preventDefault()
      else
        $("#overlay").show() unless $("#overlay").is(':visible')
        cat = form.data().gaCategory
        act = form.data().gaAction
        if form.hasClass('iubenda') and not form.data().resend? # Iubenda
          event.preventDefault()
          submitIubendaForm(form)
          form.data().resend = true
        else if cat? and act? and not form.data().gaOk? # Tracciamento evento su Google Analytics
          event.preventDefault()
          label = form.data().gaLabel
          value = form.data().gaValue
          register_event(cat, act, label, value)
          form.data().gaOk = true
          form.submit()
        else if form.data().leadUrl? and not form.data().leadOk? # Creazione di un Lead
          event.preventDefault()
          _data = {}
          form.find('input[disabled]').each ->
            _data[$(@).attr('name')] = $(@).val()
          $.ajax
            type: 'POST'
            url: form.data().leadUrl
            dataType: 'json'
            data: _data
            complete: ->
              form.data().leadOk = true
              form.submit()

    form.on 'ta:iubenda_success', ->
      form.submit()

    form.on 'ta:iubenda_error', ->
      alert 'Si è verificato un errore. Riprova più tardi'

    if form.data().leadUrl?
      form.find('input[name="email"]').on 'change', ->
        form.find('input[name="lead[email]"]').val $(@).val()

      form.find('input[name="email_confirmation"]').on 'change', ->
        form.find('input[name="lead[email_confirmation]"]').val $(@).val()

    form.find('input[data-tavalidate="true"], select[data-tavalidate="true"]').each ->
      field = $(@)
      if field.attr('type') == 'checkbox'
        field.on 'change', ->
          unless Validator.presence(field)
            msg = "Spunta questa casella"
            Validator.addError field, msg
            ok = false
          else
            Validator.removeError field
      else
        field.on 'focuout', ->
          if field.attr('type') == 'email'
            unless Validator.format(email, Validator.email_regexp)
              Validator.addError emaifieldl, "Email non vailda"
              ok = false
            else
              Validator.removeError email
          else
            unless Validator.presence(field)
              Validator.addError field, "Devi compilare questo campo"
              ok = false
            else
              Validator.removeError field
# Fine validazione form

# Aggiungo classe per animazione form
$ ->
  $('.animated-form').each ->
    if $(@).offset().top < $(window).height()
      $(@).addClass('slideRight') #rollIn

$(document).on 'scroll', (event)->
  documentScroll = document.getScroll()
  scroll_top = documentScroll[1]
  $('.animated-form').each ->
    if not $(@).hasClass('slideRight') and (scroll_top >= $(@).position().top or (scroll_top >= ($(document).height() - $(window).height() - ($(document).height() - $(@).position().top)) && $(@).position().top > scroll_top))
      $(@).addClass('slideRight') #rollIn

$(document).on 'click', (event)->
  if $(event.target).parents('#menu-top').length == 0 and $(event.target).parents('#menu-ass').length == 0 and $(event.target).parents('#menu-top-small').length == 0 and $(event.target).attr('id') != 'menu-top-small' and $(event.target).parents('.children').length == 0
    close_submenus(true)

# Acchiappone Tour
dCookie = document.cookie.match(/\b_amtt=([^;]*)/)

show_acchiappone_tour = ->
  unless WURFL.is_mobile
    $("#acchiappone_tour_overlay").fadeIn("fast")

hide_acchiappone_tour = ->
  $("#acchiappone_tour_overlay").fadeOut("fast")
  $(window).trigger 'closeAcchiappino'

submit_acchiappone_tour = (form)->
  email_rg = /^([\w\.\-\+]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/
  unless email_rg.test(form.find('#email').val())
    alert("Indirizzo email non valido!")
  else
    if form.find('#slug').length > 0
      slug = form.find('#slug').val()
    else
      slug = null
    if form.find('#trattamento-acchiappino').length > 0
      trattamento = form.find('#trattamento-acchiappino')
    else if form.find('#trattamento-acchiappone').length > 0
      trattamento = form.find('#trattamento-acchiappone')
    else
      trattamento = null
    if slug == ''
      alert("Seleziona un'opzione")
    else if trattamento and not trattamento.is(':checked')
      alert("Spunta la casella sul trattamento dei dati")
    else
      $("#overlay").show()
      $.ajax
        type: 'POST'
        url: form.attr('action')
        data: form.serialize()
        complete: (xhr)->
          submitIubendaForm(form) if form.hasClass('iubenda')
          rp = if form.data().redirect then form.data().redirect else '/pagina-di-ringraziamento/'
          window.location = rp

$ ->
  $('#form-acchiappone-tour').on 'submit', (event)->
    event.preventDefault()
    form = $(this)
    submit_acchiappone_tour(form)

  $("#acchiappone_tour_mail_close").on "click", (event)->
    event.preventDefault()
    hide_acchiappone_tour()

  $("#acchiappone_tour_overlay").on "click", (e)->
    if $(@).is(":visible") and e.target.getAttribute("id") == "acchiappone_tour_overlay"
      hide_acchiappone_tour()

  if $("#acchiappone_tour_overlay").length > 0
    if not dCookie or not dCookie[1] or dCookie[1] == "0"
      document.cookie = "_amtt=1; path=/; domain=." + location.hostname.split(".").slice(-2).join(".") + "; expires=" + (new Date((new Date).getTime() + 1000 * 60 * 60 * 24)).toGMTString()
      setTimeout ->
        show_acchiappone_tour()
      , 10000
# Fine Acchiappone Tour

# Acchiappino tour
$ ->
  if typeof WURFL == "undefined"
    script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = (if 'https:' == document.location.protocol then 'https://' else 'http://') + 'wurfl.io/wurfl.js'
    s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(script, s)
  window.interval_load_wurfl = setInterval ->
    if typeof WURFL != "undefined"
      clearInterval window.interval_load_wurfl
      if $('#acchiappino_mail_tour').length == 1 and not WURFL.is_mobile
        if $("#acchiappone_tour_overlay").length > 0 and (not dCookie or not dCookie[1] or dCookie[1] == "0")
          $(window).on 'closeAcchiappino', ->
            setTimeout ->
              $('#acchiappino_mail_tour').animate
                right: 0
              , 1000
            , 3000
        else
          setTimeout ->
            $('#acchiappino_mail_tour').animate
              right: 0
            , 1000
          , 10000

        $('#acchiappino_mail_tour_close').on 'click', (event)->
          event.preventDefault()
          $('#acchiappino_mail_tour').animate
            right: -410
          , 1000

        $('#form-acchiappino-tour').on 'submit', (event)->
          event.preventDefault()
          form = $(this)
          submit_acchiappone_tour(form)

      if $('#acchiappino_controllo').length == 1 and not WURFL.is_mobile
        if $("#acchiappone_tour_overlay").length > 0 and (not dCookie or not dCookie[1] or dCookie[1] == "0")
          $(window).on 'closeAcchiappino', ->
            setTimeout ->
              $('#acchiappino_controllo').animate
                right: 0
              , 1000
            , 3000
        else
          setTimeout ->
            $('#acchiappino_controllo').animate
              right: 0
            , 1000
          , 10000

        $('#acchiappino_controllo_close').on 'click', (event)->
          event.preventDefault()
          $('#acchiappino_controllo').animate
            right: -410
          , 1000

        $('#form-acchiappino-controllo').on 'submit', (event)->
          event.preventDefault()
          form = $(this)
          submit_acchiappone_tour(form)
  , 1000
# Fine Acchiappino tour